export default "__VITE_ASSET__3mLswO6H__"